import React, {useEffect, useState} from "react";
import {ColorPicker} from "antd";
import Color from "color";

const StyleColourPicker = props => {
    const {defaultValue, onChange, ...other} = props;
    const [colour, setColour] = useState();

    useEffect(() => {
        setColour(defaultValue ? parseColour(defaultValue) : null);
    }, [defaultValue]);

    function parseColour(colour) {
        if (typeof colour === "string") {
            if (colour === 'var(--border-colour)') return Color("#ff0000");
            return Color(colour);
        } else if (colour && typeof colour.toHexString === "function") {
            return Color(colour.toHexString());
        }
        return null;
    }

    const handleColourChange = colour => {
        const newColour = parseColour(colour);
        setColour(newColour);
        if (onChange && typeof onChange === "function") {
            onChange(newColour);
        }
    };

    return (
        <>
            <ColorPicker
                format={"hex"}
                value={colour ? colour.hex() : undefined}
                disabledAlpha
                // showText={(color) => <span>{color.toHexString()}</span>}
                onChange={handleColourChange}
                {...other}
            />
        </>
    )
}

export default StyleColourPicker;